<template>
  <div  class="app-main-content">
    <div>
      <h1 v-if="$store.state.guestLogin.mfaStep != 4">Multi Factor Authentication (MFA)</h1>
      <div><SystemAlert/></div>
      <slot v-if="$store.state.guestLogin.mfaStep == 1">
        <ContactDetails />
      </slot>
      <slot v-if="$store.state.guestLogin.mfaStep == 2">
        <Otp />
      </slot>
      <slot v-if="$store.state.guestLogin.mfaStep == 3">
        <OtherDetails />
      </slot>
      <slot v-if="$store.state.guestLogin.mfaStep == 4">
        <UserDD />
      </slot>
      <slot v-if="$store.state.guestLogin.mfaStep == 5">
        <OtpByMail />
      </slot>

    </div>
  </div>
</template>



<script>
import ContactDetails from '../../components/multiFactorAuth/ContactDetails.vue';
import Otp from '../../components/multiFactorAuth/Otp.vue';
import OtherDetails from '../../components/multiFactorAuth/OtherDetails.vue';
import UserDD from '../../components/multiFactorAuth/UserDD.vue';
import OtpByMail from '../../components/multiFactorAuth/OtpByMail.vue'
import SystemAlert from '@/components/SystemAlert';

export default {
  name: 'MFA',
  components: {
    ContactDetails,
    Otp,
    OtherDetails,
    UserDD,
    OtpByMail,
    SystemAlert
},
  data() {
    return {
      screenData: {},
      // mfaStep: this.$store.state.guestLogin.mfaStep,
    }
  },
  computed: {

  },
  created() {

  },
  watch: {

  },
  methods: {

  }
}
</script>